import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  ClientDetailsPage,
  CLIENT_SCOPES,
} from "../../modules/client-management";
import TenantContextBanner from "../../components/common/TenantContextBanner";
import useAuth from "../../hooks/useAuth";

const ClientDetails = () => {
  const { isTenantUser, isSystemUser, activeTenantId } = useAuth();
  const location = useLocation();
  const isTenantScope =
    isTenantUser || location.pathname.startsWith("/tenant-");

  if (isSystemUser && isTenantScope && !activeTenantId) {
    return <Navigate to="/tenantmgmt" replace />;
  }

  return (
    <>
      {isTenantScope && !isTenantUser ? <TenantContextBanner /> : null}
      <ClientDetailsPage
        scope={isTenantScope ? CLIENT_SCOPES.TENANT : CLIENT_SCOPES.SYSTEM}
      />
    </>
  );
};

export default ClientDetails;
